"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
const columnsData = [{
  title: "Measure",
  description: "We Measure through advanced lab testing.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_measure.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_measure.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_measure.png-wvc-sizes",
    alt: "Precision laboratory tools for measuring health baselines"
  }
}, {
  title: "Optimize",
  description: "Optimize with high-quality, targeted supplementation to correct deficiencies and support total-body function.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_optimize.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_optimize.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_optimize.png-wvc-sizes",
    alt: "Targeted high-quality supplementation"
  }
}, {
  title: "Maintain",
  description: "Maintained through continuous tracking and refinement.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_maintain.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_maintain.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/lab_precision_maintain.png-wvc-sizes",
    alt: "Continuous health tracking and refinement tools"
  }
}];
export default function LLaboratorySupplement() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="l-laboratory-supplement" className="bg-background">
      <div className="bg-card py-32">
        <div className="container mx-auto px-4 md:px-6">
          {}
          <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="text-sm font-bold tracking-widest uppercase text-muted-foreground mb-4 block">
              Supplements + Lab Testing
            </span>
            <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-6 leading-tight">
              Data-driven health, simplified.
            </h2>
            <div className="flex justify-center">
              <Separator className="w-24 h-1 bg-primary/20 rounded-full" />
            </div>
          </div>

          {}
          <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {columnsData.map((col, i) => <div key={i} data-index={i} className={`transition-all duration-1000 ease-out delay-${i * 200} ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="bg-transparent border-none shadow-none h-full flex flex-col">
                  <div className="mb-8 overflow-hidden rounded-xl bg-muted/50">
                    <AspectRatio ratio={4 / 3}>
                      <img src={col.image.src} data-wvc-srcset={col.image.srcset} data-wvc-sizes={col.image.sizes} alt={col.image.alt} loading="lazy" className="object-cover w-full h-full grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-700 ease-in-out" />
                    </AspectRatio>
                  </div>
                  <CardHeader className="px-0 pt-0 pb-4 text-center">
                    <CardTitle className="font-default font-bold uppercase text-foreground text-xl" style={{
                  letterSpacing: "var(--tracking-brand-widest, 0.4em)"
                }}>
                      {col.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-0 text-center flex-grow">
                    <p className="text-muted-foreground leading-relaxed">
                      {col.description}
                    </p>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}